<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { get } from "lodash";
import VueButton from "vue-button";

export default {
  props: {
    animation: {
      type: Boolean,
      default: true
    },
    miniformatTitle: {
      type: String,
      default: null
    },
    textWidth: {
      type: Number,
      default: 6
    }
  },
  components: {
    VueButton
  },
  mixins: [fandomBasicMixin],
  methods: {
    expandUrl: Fandom.expandUrl,
    getButtonClass: Fandom.getButtonClass
  },
  computed: {
    backgroundVideoUrl() {
      const videoDesktop = get(this, "content.background_video.url", false);
      return get(globalState, "viewport.xs", false) ? get(this, "content.background_video_mobile.url", videoDesktop) : videoDesktop;
    },
    animationZoomClass() {
      if (this.animation) {
        return "inview_animate_zoom";
      }
    },
    textAlign() {
      return get(this.content, "text_align", "center");
    },
    textContainerClasses() {
      return [
        `align-items-${this.textAlign == "left" ? "start" : this.textAlign == "right" ? "end" : "center"}`,
        `col-md-${this.textWidth}`
      ]
    },
    category() {
      return this.content.category ? this.content.category : this.miniformatTitle ? this.miniformatTitle : false;
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" class="position-absolute-center" :class="contentType" tile-carousel-fullscreen-component>
    <div class="bg-cover-center position-absolute-center" :style="{'background-color': content.background_color, 'background-image': getContentResponsiveImageURL('background_image')}" :class="animationZoomClass">
    </div>
    <div v-if="backgroundVideoUrl" class="video-16by9 position-absolute-center h-100vh">
      <video loop webkit-playsinline playsinline>
        <source :src="expandUrl(backgroundVideoUrl)" type="video/mp4">
      </video>
    </div>
    <div v-if="!content.hide_gradient" class="layer position-absolute-center"></div>
    <div class="d-flex flex-column justify-content-center position-absolute-center p-5">
      <div class="row justify-content-center text-center align-items-center">
        <div class="col-12 d-flex flex-column justify-content-center" :class="textContainerClasses">
          <img v-if="content.icon" :src="expandUrl(content.icon.url)" class="mb-4 slide-icon" />
          <div v-if="category" class="category my-1">{{category}}</div>
          <component :is="content.title_tag || 'h2'" v-if="content.title && !content.icon" class="display-2">{{content.title}}</component>
          <component :is="content.description_tag || 'h4'" class="mt-3" v-if="content.description" v-html="content.description"></component>
          <vue-button
            tag="a"
            class="mt-3"
            v-if="content.button" 
            :button="content.button"
            :buttonClass="['btn shadow-none btn-light']"
          ></vue-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[tile-carousel-fullscreen-component] {
  
  .slide-icon {
    width: 9rem;
    max-width: 50%;
  }

  @include media-breakpoint-up(xs) {
    .slide-icon {
      max-width: 75%;
    }
  }

  @include media-breakpoint-down(xs) {
    .video-16by9 video {
      /* reverse aspect ratio */
      height: 177.78vw !important;
      width: 56.25vh !important;
    }
  }
}
</style>
